import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { X, Save, Loader2, FileText } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function EditChapterModal({ chapter, onClose, onUpdate }) {
  const [title, setTitle] = useState(chapter.title);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!title.trim()) {
      toast.error('Please enter a title');
      return;
    }

    setSaving(true);
    try {
      const response = await axios.put(
        `${API}/chapters/${chapter.chapter_id}`,
        { title: title.trim() },
        
      );
      
      toast.success('Chapter renamed!');
      onUpdate(response.data);
      onClose();
    } catch (error) {
      console.error('Failed to update chapter:', error);
      toast.error('Failed to update chapter');
    } finally {
      setSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-[#22201C] rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-[#2A2520]/50">
          <div className="flex items-center space-x-3">
            <FileText className="w-6 h-6 text-[#7C766E]" />
            <h2 className="text-xl font-bold text-[#2A2420] dark:text-[#F0EBE4]">
              Rename Chapter {chapter.chapter_number}
            </h2>
          </div>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6">
          <label className="block text-sm font-medium text-[#2A2420] dark:text-[#F0EBE4] mb-2">
            Chapter Title
          </label>
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Enter chapter title"
            autoFocus
            data-testid="edit-chapter-title"
            className="w-full"
          />
          <p className="text-xs text-[#2A2420]/60 dark:text-[#F0EBE4]/60 mt-2">
            Press Enter to save
          </p>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 dark:border-[#2A2520]/50">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={saving || !title.trim()}
            className="bg-[#8B7355] hover:bg-[#7A6347] text-white"
            data-testid="save-chapter-button"
          >
            {saving ? (
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            ) : (
              <Save className="w-4 h-4 mr-2" />
            )}
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EditChapterModal;
